module.exports = __webpack_public_path__ + "static/img/3.2ac1d83.png";


//////////////////
// WEBPACK FOOTER
// ./static/honour/3.png
// module id = y2sE
// module chunks = 1